import { meta } from '@/helpers/constants/router';
import { OVERVIEW_ROUTE, PERFORMANCE_ROUTE, PRODUCTS_ROUTE, CATEGORIES_ROUTE, INQUIRIES_ROUTE, BROADCAST_ROUTE, CUSTOMER_SEGMENT_ROUTE, BROADCAST_ROUTE_SMS, BROADCAST_ROUTE_FB, } from '@/helpers/constants/InquiryRoutes';
import { BroadcastTarget } from '@/helpers/entities/enums/v2/BroadcastTarget';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Wrapper = () => import('@/views/Wrapper.vue');
export default [
    {
        path: 'inquiry',
        component: Wrapper,
        meta: { ...meta, title: 'Inquiry' },
        children: [
            {
                path: 'products',
                component: Wrapper,
                redirect: PRODUCTS_ROUTE.name,
                meta: { ...meta, title: 'Products' },
                children: [
                    {
                        path: ':componentUUID',
                        component: Wrapper,
                        children: [
                            {
                                path: 'inquiry-crm',
                                component: Wrapper,
                                meta: { ...meta, title: CUSTOMER_SEGMENT_ROUTE.title },
                                children: [
                                    {
                                        path: '/',
                                        name: CUSTOMER_SEGMENT_ROUTE.name,
                                        meta: { title: CUSTOMER_SEGMENT_ROUTE.title },
                                        component: () => import('@/views/v2/Customers.vue'),
                                    },
                                ],
                            },
                            {
                                path: 'categories',
                                component: Wrapper,
                                meta,
                                children: [
                                    {
                                        path: '/',
                                        name: CATEGORIES_ROUTE.name,
                                        component: () => import('@/views/v2/inquiry/Categories.vue'),
                                        meta: {
                                            title: CATEGORIES_ROUTE.title,
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                    {
                                        path: 'create',
                                        name: 'inquiry-categories-create',
                                        component: () => import('@/views/v2/inquiry/CategoryCreate.vue'),
                                        meta: {
                                            title: 'Create Category',
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                    {
                                        path: ':uuid',
                                        meta: { title: CATEGORIES_ROUTE.title },
                                        component: Wrapper,
                                        children: [
                                            {
                                                path: 'edit',
                                                name: 'inquiry-categories-edit',
                                                component: () => import('@/views/v2/inquiry/CategoryEdit.vue'),
                                                props: true,
                                                meta: {
                                                    title: 'Edit Category',
                                                    parentMenu: PRODUCTS_ROUTE.name,
                                                },
                                            },
                                            {
                                                path: 'details',
                                                name: 'inquiry-category-details',
                                                component: () => import('@/views/v2/inquiry/CategoryDetails.vue'),
                                                props: true,
                                                meta: {
                                                    title: 'Details',
                                                    parentMenu: PRODUCTS_ROUTE.name,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: '/',
                                name: PRODUCTS_ROUTE.name,
                                component: () => import('@/views/v2/inquiry/Products.vue'),
                                meta: {
                                    title: PRODUCTS_ROUTE.title,
                                    parentMenu: PRODUCTS_ROUTE.name,
                                },
                            },
                            {
                                path: 'create',
                                name: 'inquiry-products-create',
                                component: () => import('@/views/v2/inquiry/ProductNew.vue'),
                                meta: {
                                    title: 'Create Product',
                                    parentMenu: PRODUCTS_ROUTE.name,
                                },
                            },
                            {
                                path: ':uuid',
                                meta: { title: PRODUCTS_ROUTE.title },
                                component: Wrapper,
                                children: [
                                    {
                                        path: 'edit',
                                        name: 'inquiry-products-edit',
                                        component: () => import('@/views/v2/inquiry/ProductEdit.vue'),
                                        props: true,
                                        meta: {
                                            title: 'Edit Product',
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                    {
                                        path: 'details',
                                        name: 'inquiry-product-details',
                                        component: () => import('@/views/v2/inquiry/ProductDetails.vue'),
                                        props: true,
                                        meta: {
                                            title: 'Details',
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'inquiries',
                component: Wrapper,
                meta: { ...meta, title: INQUIRIES_ROUTE.title },
                children: [
                    {
                        path: ':uuid',
                        meta: { title: INQUIRIES_ROUTE.title },
                        component: Wrapper,
                        children: [
                            {
                                path: '/',
                                name: 'inquiry-details',
                                props: true,
                                meta: {
                                    title: INQUIRIES_ROUTE.title,
                                },
                                component: () => import('@/views/v2/inquiry/InquiryDetails.vue'),
                            },
                        ],
                    },
                    {
                        path: '/',
                        name: INQUIRIES_ROUTE.name,
                        meta: {
                            title: INQUIRIES_ROUTE.title,
                        },
                        component: () => import('@/views/v2/inquiry/Inquiries.vue'),
                    },
                    {
                        path: ':status',
                        name: 'inquiry-by-status',
                        props: true,
                        meta: {
                            title: INQUIRIES_ROUTE.title,
                        },
                        component: () => import('@/views/v2/inquiry/Inquiries.vue'),
                    },
                ],
            },
            {
                path: 'overview',
                component: Wrapper,
                meta: { ...meta, title: OVERVIEW_ROUTE.title },
                children: [
                    {
                        path: '/',
                        component: Wrapper,
                        meta: {
                            title: 'Overview',
                            redirect: OVERVIEW_ROUTE.name,
                        },
                        children: [
                            {
                                path: '/',
                                name: OVERVIEW_ROUTE.name,
                                component: () => import('@/views/v2/inquiry/Overview.vue'),
                                meta: {
                                    title: OVERVIEW_ROUTE.title,
                                },
                            },
                            {
                                path: 'popular-products',
                                name: 'inquiry-products-by-popularity',
                                component: () => import('@/views/v2/inquiry/PopularProductList.vue'),
                                meta: {
                                    title: 'Most Viewed Products',
                                    parentMenu: OVERVIEW_ROUTE.name,
                                },
                            },
                            {
                                path: 'general-inquiries',
                                name: 'inquiry-general-inquiries',
                                component: () => import('@/views/v2/inquiry/GeneralInquiries.vue'),
                                meta: {
                                    title: 'General Inquiries',
                                    parentMenu: OVERVIEW_ROUTE.name,
                                },
                            },
                            {
                                path: 'product-inquiries',
                                name: 'inquiry-product-inquiries',
                                component: () => import('@/views/v2/inquiry/ProductInquiries.vue'),
                                meta: {
                                    title: 'Product Inquiries',
                                    parentMenu: OVERVIEW_ROUTE.name,
                                },
                            },
                        ],
                    },
                    {
                        path: 'performance',
                        component: Wrapper,
                        meta: {
                            title: 'Mini App Performance',
                            redirect: PERFORMANCE_ROUTE.name,
                        },
                        children: [
                            {
                                path: '/',
                                name: PERFORMANCE_ROUTE.name,
                                component: () => import('@/views/v2/inquiry/Performance.vue'),
                                meta: {
                                    title: PERFORMANCE_ROUTE.title,
                                },
                            },
                            {
                                path: 'popular-categories',
                                name: 'inquiry-categories-by-popularity',
                                component: () => import('@/views/v2/inquiry/PopularCategoryList.vue'),
                                meta: {
                                    title: 'Most Viewed Categories',
                                    parentMenu: PERFORMANCE_ROUTE.name,
                                },
                            },
                            {
                                path: 'popular-products-by-views',
                                name: 'inquiry-popular-product-by-views',
                                component: () => import('@/views/v2/inquiry/PopularProductByViews.vue'),
                                meta: {
                                    title: 'Most Viewed Products',
                                    parentMenu: PERFORMANCE_ROUTE.name,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'broadcast',
                component: Wrapper,
                meta: { ...meta, title: BROADCAST_ROUTE.title, redirect: BROADCAST_ROUTE.name },
                children: [
                    {
                        path: '/',
                        name: BROADCAST_ROUTE_FB.name,
                        meta: {
                            title: BROADCAST_ROUTE_FB.title,
                            parentMenu: BROADCAST_ROUTE.name,
                        },
                        component: () => import('@/views/v2/Broadcast.vue'),
                    },
                    {
                        path: 'sms',
                        name: BROADCAST_ROUTE_SMS.name,
                        meta: {
                            title: BROADCAST_ROUTE_SMS.title,
                            parentMenu: BROADCAST_ROUTE.name,
                        },
                        component: () => import('@/views/v2/Broadcast.vue'),
                        props: {
                            target: BroadcastTarget.SMS,
                        },
                    },
                ],
            },
            {
                path: 'notifications',
                name: 'inquiry-notifications',
                component: () => import('@/views/v2/NotificationsManager.vue'),
                meta: { ...meta, title: 'Notification Manager' },
                redirect: { name: 'inquiry-notifications-manager-email' },
                children: [
                    {
                        path: 'fb-messenger',
                        name: 'inquiry-notifications-manager-fb-messenger',
                        meta: { title: 'Notification Manager', parentMenu: 'inquiry-notifications' },
                        component: () => import('@/views/v2/NotificationsFbMessenger.vue'),
                    },
                    {
                        path: 'email',
                        name: 'inquiry-notifications-manager-email',
                        meta: { title: 'Notification Manager', parentMenu: 'inquiry-notifications' },
                        component: () => import('@/views/v2/NotificationsEmail.vue'),
                    },
                ],
            },
        ],
    },
];
